import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 获取省公司列表（总部和子公司）
  getZbCompanyList() {
    return request({
      url: '/business/account/getPermissionCompany',
      method: 'POST'
    })
  },
  // 添加账号
  addAccount(data) {
    return request({
      url: '/business/account/add',
      method: 'POST',
      data
    })
  },
  // 编辑账号
  modifyAccount(data) {
    return request({
      url: '/business/account/modify',
      method: 'POST',
      data
    })
  },
  // 账号详情
  getAccountDetail(data) {
    return request({
      url: '/business/account/detail',
      method: 'POST',
      data
    })
  },
  // 停用，启用账号
  postBusinessAcountSwitchState(data = {}) {
    return request({
      url: '/business/account/switchState',
      method: 'POST',
      data
    })
  },
  // 修改密码
  modifyAccountPwd(data) {
    return request({
      url: '/business/account/modifyPwd',
      method: 'POST',
      data
    })
  },
  // 修改手机号
  modifyAccountPho(data) {
    return request({
      url: '/business/account/modifyTel',
      method: 'POST',
      data
    })
  },
  // 批量修改直属上级
  batchUpdateLeader(data) {
    return request({
      url: '/business/account/batchUpdateLeader',
      method: 'POST',
      data
    })
  },
  // 批量修改部门
  batchUpdateDepartment(data) {
    return request({
      url: '/business/account/batchUpdateDepartment',
      method: 'POST',
      data
    })
  }
}
